export class GISType {
  static readonly Activity = new GISType(
    "activity",
    "Survey",
    "ActivityNumber",
  );
  static readonly Site = new GISType("site", "Site", "iResourceID");
  static readonly StateRegister = new GISType(
    "state_register",
    "State Register",
    "iResourceID",
  );
  static readonly Object = new GISType("object", "Object", "iResourceID");
  static readonly Structure = new GISType(
    "structure",
    "Historic Structure",
    "iResourceID",
  );
  static readonly Building = new GISType("building", "Building", "iResourceID");
  static readonly LinearResource = new GISType(
    "linear resource",
    "Linear Resource",
    "iResourceID",
  );
  static readonly District = new GISType(
    "district",
    "Historic District",
    "iResourceID",
  );
  static readonly Covenant = new GISType("covenant", "Covenant", "iCovenantID");

  private constructor(
    private readonly key: string,
    public readonly humanReadable: string,
    public readonly Id: string,
  ) {}

  public static fromString(key: string): GISType | null {
    switch (key) {
      case GISType.Activity.key:
        return GISType.Activity;
      case GISType.Site.key:
        return GISType.Site;
      case GISType.StateRegister.key:
        return GISType.StateRegister;
      case GISType.Object.key:
        return GISType.Object;
      case GISType.Structure.key:
        return GISType.Structure;
      case GISType.Building.key:
        return GISType.Building;
      case GISType.LinearResource.key:
        return GISType.LinearResource;
      case GISType.District.key:
        return GISType.District;
      case GISType.Covenant.key:
        return GISType.Covenant;
    }
    return null;
  }
}
